"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactBootstrap = require("react-bootstrap");
require("moment/locale/es-us");
var _material = require("@mui/material");
var _menu = _interopRequireDefault(require("./menu"));
var _dayPickerSingleDate = _interopRequireDefault(require("./dayPickerSingleDate"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var _constants = _interopRequireDefault(require("../constants"));
var _buttonV = _interopRequireDefault(require("../buttonV2"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DATE_FORMAT = _constants.default.DateTimeFormat.shortDate;
var CLASS_NAME = _styles.default['date-single-picker'];
var CLASS_NAME_INPUT = _styles.default['input-group'];
/**
 * DateSinglePicker
 * @extends Component
 */
var DateSinglePicker = /*#__PURE__*/function (_Component, _onSelectRange) {
  (0, _inherits2.default)(DateSinglePicker, _Component);
  var _super = _createSuper(DateSinglePicker);
  /**
   * Constructor
   * @param {Object} props The props
   */
  function DateSinglePicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DateSinglePicker);
    _this = _super.call(this, props);
    _this.state = {
      isOpenDropDown: false,
      selectedDate: props.date,
      anchor: null
    };
    _this.openDropdown = _this.openDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSelectRange = _this.onSelectRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDateChange = _this.onDateChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.isOutsideRange = _this.isOutsideRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onApply = _this.onApply.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancel = _this.onCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUpdateSelectedItem = _this.onUpdateSelectedItem.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(DateSinglePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onUpdateSelectedItem();
      _momentTimezone.default.locale(this.props.locale);
    }
  }, {
    key: "onUpdateSelectedItem",
    value: function onUpdateSelectedItem() {
      var _this$props = this.props,
        date = _this$props.date,
        filterRanges = _this$props.filterRanges;
      if (date && !this.state.selectedItem) {
        this.setState({
          selectedItem: filterRanges.CUSTOM_DATE,
          isOpenRangePicker: true
        });
      }
    }
  }, {
    key: "onSelectRange",
    value: function onSelectRange(_x, _x2) {
      return (_onSelectRange = _onSelectRange || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(nameDatePicker, date) {
        var _this$state, isOpenDropDown, selectedItem, _this$props2, onChange, filterRanges;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$state = this.state, isOpenDropDown = _this$state.isOpenDropDown, selectedItem = _this$state.selectedItem;
              _this$props2 = this.props, onChange = _this$props2.onChange, filterRanges = _this$props2.filterRanges; // Prevent double click on custom range filter
              if (!(nameDatePicker === filterRanges.CUSTOM_DATE && selectedItem === filterRanges.CUSTOM_DATE)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (!date) {
                _context.next = 11;
                break;
              }
              _context.next = 7;
              return onChange({
                nameDatePicker: nameDatePicker,
                date: date
              });
            case 7:
              this.batchStateUpdates({
                prevSelectedItem: selectedItem,
                selectedItem: nameDatePicker,
                selectedDate: date,
                isOpenRangePicker: false
              });
              this.setState({
                isOpenDropDown: false
              });
              _context.next = 12;
              break;
            case 11:
              this.setState({
                prevSelectedItem: selectedItem,
                selectedItem: nameDatePicker,
                isOpenRangePicker: true,
                isOpenDropDown: isOpenDropDown
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
    /**
     * onDateChange
     * @param  {Moment}  day The new date
     * Otherwise, return false
     */
  }, {
    key: "onDateChange",
    value: function onDateChange(day) {
      this.setState({
        selectedDate: day
      });
    }
  }, {
    key: "onApply",
    value: function onApply() {
      var _this$state2 = this.state,
        selectedDate = _this$state2.selectedDate,
        selectedItem = _this$state2.selectedItem;
      this.setState({
        isOpenDropDown: false,
        prevSelectedItem: selectedItem
      });
      this.props.onChange(selectedDate);
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      var _this$props3 = this.props,
        date = _this$props3.date,
        filterRanges = _this$props3.filterRanges;
      var _this$state3 = this.state,
        prevSelectedItem = _this$state3.prevSelectedItem,
        selectedItem = _this$state3.selectedItem,
        isOpenRangePicker = _this$state3.isOpenRangePicker;
      var newSelectedItem = selectedItem;
      var openRangePicker = isOpenRangePicker;
      if (prevSelectedItem && prevSelectedItem !== filterRanges.CUSTOM_DATE) {
        newSelectedItem = prevSelectedItem;
        openRangePicker = false;
      }
      this.batchStateUpdates({
        selectedItem: newSelectedItem,
        isOpenRangePicker: openRangePicker,
        selectedDate: date
      });
      this.setState({
        anchor: null,
        isOpenDropDown: false
      });
    }
  }, {
    key: "getFilterRanges",
    value: function getFilterRanges() {
      var newRanges = _lodash.default.clone(this.props.ranges);
      newRanges[this.props.filterRanges.CUSTOM_DATE] = null;
      return newRanges;
    }

    /**
     * Sets the state of the component with the provided updates after a delay of 500 milliseconds.
     *
     * @param {object} updates - An object containing the updated state values.
     */
  }, {
    key: "batchStateUpdates",
    value: function batchStateUpdates(updates) {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState(updates);
      }, 500);
    }
  }, {
    key: "isOutsideRange",
    value: function isOutsideRange(renderDate) {
      var blocked = true;
      var _this$props4 = this.props,
        maxDate = _this$props4.maxDate,
        minDate = _this$props4.minDate;
      if (renderDate.isBefore(minDate, 'days') || renderDate.isAfter(maxDate, 'days')) {
        // If the {renderDate} is not between minDate and startDate, should block.
        return blocked;
      }
      return !blocked;
    }
  }, {
    key: "openDropdown",
    value: function openDropdown(e) {
      e.preventDefault();
      this.setState({
        isOpenDropDown: true
      });
    }
  }, {
    key: "renderToggleControl",
    value: function renderToggleControl() {
      var _this$props5 = this.props,
        date = _this$props5.date,
        placeholder = _this$props5.placeholder,
        disabled = _this$props5.disabled,
        readOnly = _this$props5.readOnly;
      var value = date && (0, _momentTimezone.default)(date).format(DATE_FORMAT);
      var id = "input-date-single-picker-".concat(new Date().getTime());
      var className = date ? 'date-input_value' : 'date-input_placeholder';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: CLASS_NAME_INPUT
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
        type: "text",
        id: id,
        className: "input-date-single-picker ".concat(className, " ").concat(disabled ? 'disabled' : ''),
        onClick: this.openDropdown,
        bsRole: "toggle",
        disabled: disabled,
        value: value,
        readOnly: readOnly,
        placeholder: placeholder
      }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ControlLabel, {
        htmlFor: id,
        bsClass: "input-group-addon btn"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "fa fa-calendar"
      })));
    }
  }, {
    key: "renderDateTimePicker",
    value: function renderDateTimePicker() {
      var _this$props6 = this.props,
        date = _this$props6.date,
        minDate = _this$props6.minDate,
        locale = _this$props6.locale;
      return /*#__PURE__*/_react.default.createElement(_dayPickerSingleDate.default, {
        onChange: this.onDateChange,
        date: date || this.state.selectedDate,
        minDate: minDate,
        isOutsideRange: this.isOutsideRange,
        className: "date-single-picker-container",
        actionBtn: this.renderActionControl(),
        locale: locale
      });
    }
  }, {
    key: "renderActionControl",
    value: function renderActionControl() {
      var selectedDate = this.state.selectedDate;
      var _this$props7 = this.props,
        date = _this$props7.date,
        t = _this$props7.t;
      var disabledApplyBtn = !date && !selectedDate || selectedDate && selectedDate.isSame(date, 'day');
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonToolbar, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, null, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          className: 'cancel-btn',
          sx: {
            minWidth: 0
          },
          variant: 'text',
          color: 'text',
          onClick: this.onCancel
        }
      }, t('Cancel'))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, null, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          className: 'apply-btn',
          variant: 'text',
          id: 'date-single-apply-btn',
          onClick: this.onApply,
          disabled: disabledApplyBtn
        }
      }, t('Apply'))));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "daterangepicker-content"
      }, /*#__PURE__*/_react.default.createElement(_menu.default, {
        onSelectRange: this.onSelectRange,
        selectedItem: this.state.selectedItem,
        ranges: this.getFilterRanges(),
        t: this.props.t
      }), this.state.isOpenRangePicker && this.renderDateTimePicker());
    }

    /**
     * Render DateTimeField
     * @return {Element} React element
     */
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props8 = this.props,
        className = _this$props8.className,
        disabled = _this$props8.disabled;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(className, " ").concat(CLASS_NAME)
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        buttonType: "dropdown",
        muiButtonProps: {
          variant: 'outlined',
          color: 'secondary',
          className: 'single-date-menu',
          focusRipple: false,
          title: this.renderToggleControl(),
          endIcon: null,
          'aria-controls': this.state.isOpenDropDown ? 'button-dropdown' : undefined,
          'aria-haspopup': 'true',
          'aria-expanded': this.state.isOpenDropDown ? 'true' : undefined,
          disableElevation: true,
          onClick: function onClick(e) {
            return _this3.setState({
              anchor: e.currentTarget
            });
          },
          disabled: disabled,
          sx: {
            p: 0,
            border: 0,
            '&:hover': {
              border: 0
            }
          }
        },
        muiMenuProps: {
          open: this.state.isOpenDropDown,
          anchorEl: this.state.anchor,
          onClose: this.onCancel,
          sx: {
            '.MuiList-root': {
              p: '32px 0 32px 24px',
              minWidth: 200,
              maxHeight: 406
            }
          }
        },
        menuItems: [/*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          disableRipple: true,
          disableGutters: true,
          focusVisibleClassName: "time-picker-dropdown-focused",
          sx: {
            '&:hover': {
              background: 'none'
            },
            cursor: 'default'
          },
          className: "single-date-menu-items"
        }, this.renderContent())]
      }));
    }
  }]);
  return DateSinglePicker;
}(_react.Component); // PropTypes validation
DateSinglePicker.propTypes = {
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  date: _propTypes.default.instanceOf(_momentTimezone.default).isRequired,
  filterRanges: _propTypes.default.shape({
    CUSTOM_DATE: _propTypes.default.string
  }).isRequired,
  minDate: _propTypes.default.instanceOf(_momentTimezone.default).isRequired,
  maxDate: _propTypes.default.instanceOf(_momentTimezone.default).isRequired,
  ranges: _propTypes.default.instanceOf(Object).isRequired,
  locale: _propTypes.default.string,
  t: _propTypes.default.func
};

// Default props
DateSinglePicker.defaultProps = {
  className: '',
  placeholder: '',
  disabled: false,
  readOnly: false,
  locale: 'en-us',
  t: function t(x) {
    return x;
  }
};
var _default = DateSinglePicker;
exports.default = _default;